import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import BrandHeader from "@/components/BrandHeader";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ThankYou() {
  const { submissionId } = useParams();
  const location = useLocation();
  const initial = location.state?.submission;
  const [submission, setSubmission] = useState(initial || null);
  const [loading, setLoading] = useState(!initial);

  useEffect(() => {
    if (initial) return;
    (async () => {
      try {
        const res = await axios.get(`${API}/submissions/${submissionId}`);
        setSubmission(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [submissionId, initial]);

  const firstName = submission?.full_name ? submission.full_name.split(" ")[0] : "";

  return (
    <div className="min-h-screen">
      <BrandHeader minimal />

      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-24" data-testid="thankyou-page">
        <div className="text-xs uppercase tracking-[0.2em] text-[var(--tt-primary)] font-semibold mb-4">
          Submission received
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-tight">
          Thank you{firstName ? `, ${firstName}` : ""}.
          <br />
          <span className="text-[var(--tt-primary)]">We hear you.</span>
        </h1>

        {loading ? (
          <div className="mt-10 p-8 rounded-2xl bg-[var(--tt-surface)] border border-[var(--tt-border)] text-[var(--tt-muted)]" data-testid="loading-submission">
            Saving your responses…
          </div>
        ) : (
          <>
            <p className="mt-6 text-base sm:text-lg text-[var(--tt-muted)] leading-relaxed max-w-2xl">
              Your responses have been saved and are now with our team. We
              read every word carefully, with the care these answers deserve.
              We'll be in touch personally with the next step.
            </p>

            <div className="mt-12 rounded-2xl bg-[var(--tt-secondary)] text-white p-8 sm:p-10" data-testid="thankyou-card">
              <div className="text-xs uppercase tracking-[0.22em] text-white/60 mb-3">
                What happens next
              </div>
              <ul className="space-y-3 text-white/90 text-sm sm:text-base leading-relaxed">
                <li className="flex gap-3">
                  <span className="text-[var(--tt-accent)] font-bold">01</span>
                  Our team reviews your responses in detail.
                </li>
                <li className="flex gap-3">
                  <span className="text-[var(--tt-accent)] font-bold">02</span>
                  We'll reach out within a few days for a follow-up conversation.
                </li>
                <li className="flex gap-3">
                  <span className="text-[var(--tt-accent)] font-bold">03</span>
                  No matter what, we'll let you know either way — that's a promise.
                </li>
              </ul>
            </div>

            <p className="mt-10 text-sm text-[var(--tt-muted)] italic max-w-xl">
              Salamat. Take care of your family today — you've done the work.
            </p>
          </>
        )}

        <div className="mt-14">
          <Link
            to="/"
            data-testid="back-home-btn"
            className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-[var(--tt-border)] bg-[var(--tt-surface)] text-[var(--tt-text)] hover:border-[var(--tt-primary)] transition-colors"
          >
            ← Back to home
          </Link>
        </div>
      </main>
    </div>
  );
}
